import React from 'react';
import {
  Badge, Table, OverlayTrigger, Tooltip,
} from 'react-bootstrap';

import { floatRenderer } from '../../services/formatSvc';

export default function BudgetTableFb({ data, finSource, strategyType }) {
  const renderRow = (d) => {
    const agreement = finSource.sources.agreements.find((agr) => agr.id === d.agreementId);
    const bcCode = finSource.sources.bcCodes.find((bcCode) => bcCode.id === d.bcCodeId);
    const funding = finSource.sources.funding.find((fund) => fund.id === d.fundingId);

    return (
      <tr key={d.id}>
        <td>{agreement && agreement.name}</td>
        <td>{bcCode && bcCode.fullCode}</td>
        <td>{funding && funding.name}</td>
        <td>
          {floatRenderer(d.sum)}
&nbsp;
          {!!d.remainder && (
          <OverlayTrigger overlay={(
            <Tooltip id="tooltip-remainder">
              Превышение остатка по плану
              {' '}
              {d.isPortf ? 'портфеля' : strategyType === 'strategy' ? 'СП' : 'политики'}
              :
              {' '}
              {floatRenderer(d.remainder)}
            </Tooltip>
        )}
          >
            <Badge pill bg="danger">!</Badge>
          </OverlayTrigger>
          )}
        </td>
        <td>{floatRenderer(d.paymentSum)}</td>
      </tr>
    );
  };

  return (
    <Table striped className="read-view" style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>Соглашение</th>
          <th>Код подраздела БК</th>
          <th>Тип финансирования</th>
          <th>План, руб</th>
          <th>Факт, руб.</th>
        </tr>
      </thead>
      <tbody>
        {data.map(renderRow)}
      </tbody>
    </Table>
  );
}
